import React from "react";
import { Card } from "antd";
import { ReloadOutlined } from "@ant-design/icons";

export default function TopBoxes({ stats, onReload, refreshing }) {
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
        gap: 16,
      }}
    >
      <Card
        style={{
          background: "linear-gradient(135deg, #2563eb 0%, #60a5fa 100%)",
          border: "none",
          color: "#fff",
          boxShadow: "0 10px 24px rgba(37, 99, 235, 0.28)",
          position: "relative",
          overflow: "hidden",
        }}
        bodyStyle={{ padding: "20px 24px" }}
      >
        <div
          style={{
            position: "absolute",
            left: -40,
            bottom: -34,
            width: 140,
            height: 140,
            borderRadius: "50%",
            background: "rgba(255,255,255,0.16)",
            pointerEvents: "none",
          }}
        />
        <div
          style={{
            position: "absolute",
            right: -30,
            top: 70,
            width: 120,
            height: 70,
            borderRadius: 16,
            background: "rgba(255,255,255,0.12)",
            transform: "rotate(-8deg)",
            pointerEvents: "none",
          }}
        />
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <span style={{ color: "#fff", fontSize: 12, lineHeight: "12px" }}>✦</span>
            <span style={{ fontSize: 12, color: "rgba(255,255,255,0.85)" }}>员工数量</span>
          </div>
          <button
            type="button"
            onClick={onReload}
            style={{
              border: "none",
              background: "transparent",
              color: "rgba(255,255,255,0.95)",
              cursor: "pointer",
              padding: 0,
            }}
          >
            <ReloadOutlined className={refreshing ? "topboxes-refresh-spin" : ""} />
          </button>
        </div>
        <div style={{ fontSize: 26, fontWeight: 700, marginTop: 12, textAlign: "center" }}>
          {stats.employeeCount}
        </div>
      </Card>
      <Card
        style={{
          background: "linear-gradient(135deg, #16a34a 0%, #4ade80 100%)",
          border: "none",
          color: "#fff",
          boxShadow: "0 10px 24px rgba(22, 163, 74, 0.24)",
          position: "relative",
          overflow: "hidden",
        }}
        bodyStyle={{ padding: "20px 24px" }}
      >
        <div
          style={{
            position: "absolute",
            left: -48,
            top: 70,
            width: 150,
            height: 150,
            borderRadius: "50%",
            background: "rgba(255,255,255,0.14)",
            pointerEvents: "none",
          }}
        />
        <div
          style={{
            position: "absolute",
            right: -26,
            bottom: -16,
            width: 88,
            height: 64,
            borderRadius: 14,
            background: "rgba(255,255,255,0.16)",
            transform: "rotate(12deg)",
            pointerEvents: "none",
          }}
        />
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <span style={{ color: "#fff", fontSize: 12, lineHeight: "12px" }}>✦</span>
            <span style={{ fontSize: 12, color: "rgba(255,255,255,0.85)" }}>WhatsApp账号</span>
          </div>
          <button
            type="button"
            onClick={onReload}
            style={{
              border: "none",
              background: "transparent",
              color: "rgba(255,255,255,0.95)",
              cursor: "pointer",
              padding: 0,
            }}
          >
            <ReloadOutlined className={refreshing ? "topboxes-refresh-spin" : ""} />
          </button>
        </div>
        <div style={{ fontSize: 26, fontWeight: 700, marginTop: 12, textAlign: "center" }}>
          {stats.actCount}
        </div>
      </Card>
      <Card
        style={{
          background: "linear-gradient(135deg, #7c3aed 0%, #c084fc 100%)",
          border: "none",
          color: "#fff",
          boxShadow: "0 10px 24px rgba(124, 58, 237, 0.24)",
          position: "relative",
          overflow: "hidden",
        }}
        bodyStyle={{ padding: "20px 24px" }}
      >
        <div
          style={{
            position: "absolute",
            right: -48,
            top: 66,
            width: 160,
            height: 160,
            borderRadius: "50%",
            background: "rgba(255,255,255,0.16)",
            pointerEvents: "none",
          }}
        />
        <div
          style={{
            position: "absolute",
            left: -36,
            bottom: -22,
            width: 130,
            height: 58,
            borderRadius: 20,
            background: "rgba(255,255,255,0.12)",
            transform: "rotate(-14deg)",
            pointerEvents: "none",
          }}
        />
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <span style={{ color: "#fff", fontSize: 12, lineHeight: "12px" }}>✦</span>
            <span style={{ fontSize: 12, color: "rgba(255,255,255,0.85)" }}>快捷回复</span>
          </div>
          <button
            type="button"
            onClick={onReload}
            style={{
              border: "none",
              background: "transparent",
              color: "rgba(255,255,255,0.95)",
              cursor: "pointer",
              padding: 0,
            }}
          >
            <ReloadOutlined className={refreshing ? "topboxes-refresh-spin" : ""} />
          </button>
        </div>
        <div style={{ fontSize: 26, fontWeight: 700, marginTop: 12, textAlign: "center" }}>
          {stats.lineCount}
        </div>
      </Card>
    </div>
  );
}
